{% block sw_cms_el_config_jga_revocation_button %}
<div class="sw-cms-el-config-jga-revocation-button">
    <sw-container class="sw-cms-el-config-jga-revocation-button__content">

        <sw-text-field
            v-model="element.config.buttonText.value"
            :label="$tc('jga-revocation.cms.config.labelButtonText')"
            :placeholder="$tc('jga-revocation.cms.config.placeholderButtonText')"
        />

        <sw-single-select
            v-model="element.config.buttonStyle.value"
            :label="$tc('jga-revocation.cms.config.labelButtonStyle')"
            :options="[
                { value: 'primary', label: $tc('jga-revocation.cms.config.stylePrimary') },
                { value: 'secondary', label: $tc('jga-revocation.cms.config.styleSecondary') },
                { value: 'outline-primary', label: $tc('jga-revocation.cms.config.styleOutlinePrimary') },
                { value: 'outline-secondary', label: $tc('jga-revocation.cms.config.styleOutlineSecondary') },
            ]"
        />

        <sw-single-select
            v-model="element.config.buttonSize.value"
            :label="$tc('jga-revocation.cms.config.labelButtonSize')"
            :options="[
                { value: 'sm', label: $tc('jga-revocation.cms.config.sizeSmall') },
                { value: '', label: $tc('jga-revocation.cms.config.sizeMedium') },
                { value: 'lg', label: $tc('jga-revocation.cms.config.sizeLarge') },
            ]"
        />

    </sw-container>
</div>
{% endblock %}
